import React from "react";
import {useSelector} from 'react-redux';
import ZoomModal from "../ZoomModal";

export default function AppModal(){
    const modal = useSelector((state) => state['modal']);

    return (<div className='appModal'>
        {modal && Object.entries(modal)?.map(([name, config], i)=>{
            if(name =='ZoomModal') return <ZoomModal key={i} {...config}/>
            else return false;
         })}
    </div>)
}